import React from "react";
import styled from "styled-components";
import blueCheck from "../img/arrow2.svg";
import LandingFour from "../img/LandingFour.png";
import LandingMobileFour from "../img/LandingMobileFour.png";
import { device } from "../hooks/device";
import { useRecoilValue } from "recoil";
import { bannerOn, languageIs } from "../atoms";
import TextTwoPart from "../atomic/atom/TextTwoPart";
import TextThreePart from "../atomic/atom/TextThreePart";

interface HomeFourStyleProps {
  banner_is: boolean;
  language: string;
}

const HomeFour = () => {
  const banneris = useRecoilValue(bannerOn);
  const language = useRecoilValue(languageIs);

  return (
    <StPage banner_is={banneris} language={language}>
      <div className="wrapper">
        <div className="leftBox">
          <div className="firstPart">
            <TextTwoPart
              textEng="Easily manage proctoring sessions by"
              textKor="적립금 충전과 공유를 통한 편리한 시험 운영 "
              pc_lineheight_ko={37}
              pc_lineheight_en={37}
            />
            <TextTwoPart
              textEng="purchasing and sharing credits"
              lineheight={21}
              pc_lineheight_ko={37}
              pc_lineheight_en={37}
            />
          </div>
          <div className="middlePart">
            <div className="secondBlock">
              <TextThreePart
                textKor="모두가 함께"
                textEng="Affordable"
                pc_display="none"
                tab_display="none"
                font_family="bold"
              />
              <TextThreePart
                // className="onlyForMobile"
                textKor="이용할 수 있는"
                pc_display="none"
                tab_display="none"
                font_family="bold"
              />
              <TextThreePart
                textKor="모두가 함께 이용할 수 있는"
                textEng="Affordable"
                mobile_display="none"
                font_family="bold"
              />
              <TextTwoPart
                textKor="기업용 서비스 플랜"
                textEng="Pricing for Corporates"
                font_family="bold"
              />
            </div>

            <div className="thirdBlock">
              <div className="lineForPlan">
                <img src={blueCheck} />
                <TextTwoPart
                  textKor="적립금 구매 시 기업회원 우대 혜택 제공"
                  textEng="Get a 20% bonus when you purchase credits"
                  tab_font_size_en={14}
                />
              </div>
              <div className="lineForPlan">
                <img src={blueCheck} />
                <TextTwoPart
                  textKor="기업 적립금을 구성원과 자유롭게 공유"
                  textEng="Share your credits and points with members"
                  tab_font_size_en={14}
                />
              </div>
              <div className="lineForPlan">
                <img src={blueCheck} />
                <TextTwoPart
                  textKor="실제 응시 인원 만큼만 적립금 차감 (후불제)"
                  textEng="Credits deducted per test-taker (post-payment)"
                  tab_font_size_en={14}
                />
              </div>
            </div>
          </div>
        </div>
        <img src={LandingFour} className="rightImgBox" />
        <div className="mobileImgBox">
          <img src={LandingMobileFour} className="rightMobileImgBox" />
        </div>
      </div>
    </StPage>
  );
};

const StPage = styled.div<HomeFourStyleProps>`
  width: 100%;
  /* background: radial-gradient(189.33% 88.48% at 17.27% 20.89%, #0D2256 0%, #070F21 100%); */
  display: flex;
  align-items: center;
  .wrapper {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    align-items: center;
    width: 100%;
    overflow: hidden;
    .leftBox {
      display: flex;
      flex-direction: column;
      justify-content: center;
      grid-row: 1;
      grid-column: 2/8;
      .firstPart {
        font-size: 25px;
        font-family: "medium";
        line-height: 37px;
        color: #55a2ff;
      }
      .secondBlock {
        font-family: "bold";
        line-height: 130%;
        color: white;
      }
      .thirdBlock {
        display: grid;
        flex-direction: column;
        gap: 10px;
        color: white;
        .lineForPlan {
          display: grid;
          grid-template-columns: auto 1fr;
          gap: 8px;
          font-family: "medium";
          line-height: 36px;
          font-size: 24px;
          img {
            width: 38px;
            height: 38px;
          }
        }
      }
    }
    .rightImgBox {
      grid-row: 1;
      grid-column: 6/11;
      height: ${(props) =>
        props.banner_is ? "calc(100vh - 116px)" : "calc(100vh - 76px)"};
      padding-left: 100px;
    }
  }
  @media ${device.pc} {
    overflow: hidden;
    .wrapper {
      height: ${(props) =>
        props.banner_is ? "calc(100vh - 116px)" : "calc(100vh - 76px)"};
      .leftBox {
        .secondBlock {
          margin: 22px 0 64px;
          font-size: 62px;
        }
      }
      .rightMobileImgBox {
        display: none;
      }
    }
    .onlyForMobile {
      display: none !important;
    }
  }
  @media ${device.tabMob} {
    height: ${(props) =>
      props.banner_is ? "calc(100vh - 108px)" : "calc(100vh - 60px)"};
    min-height: 675px;
    .wrapper {
      display: flex;
      flex-direction: column;
      height: ${(props) =>
        props.banner_is ? "calc(100vh - 108px)" : "calc(100vh - 60px)"};
      min-height: 675px;
      .leftBox {
        justify-content: center;
        .firstPart {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-family: "regular";
          line-height: 18px;
          font-size: 14px;
          margin-top: 48px;
        }
        .middlePart {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: ${(props) =>
            props.banner_is ? "calc(100vh - 368px)" : "calc(100vh - 320px)"};
          min-height: 415px;
          .secondBlock {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            font-family: "medium";
            line-height: 130%;
            margin-bottom: 38px;
          }
          .thirdBlock {
            width: ${(props) => (props.language === "/ko" ? "295" : "331")}px;
            margin: 0 auto;
            .lineForPlan {
              font-size: 15px;
              font-family: "medium";
              line-height: 22px;
              gap: 4.3px;
              img {
                width: 21.5px;
                height: 21.5px;
              }
            }
          }
        }
      }
      .mobileImgBox {
        height: 194px;
        .rightMobileImgBox {
          width: 172.5px;
          height: 131px;
          margin-top: 19px;
        }
      }
      .rightImgBox {
        display: none;
      }
    }
  }
  @media ${device.tablet} {
    .onlyForMobile {
      display: none !important;
    }
    .secondBlock {
      font-size: 36px;
    }
  }
  @media ${device.mobile} {
    .secondBlock {
      font-size: 30px;
    }
  }
`;

export default HomeFour;
